export const REQUIREMENTS = [
  "Email must be from your verified company domain",
  "You must have access to the email inbox to verify",
  "Only applies to outbound ticket replies, not live chat",
  "Workspace default email is used if this is not configured",
];

export function getErrorMessage(payload) {
  if (!payload) return "Something went wrong";
  if (typeof payload === "string") return payload;
  return (
    payload.message ||
    payload.error ||
    (Array.isArray(payload.errors) && payload.errors[0]?.message) ||
    "Something went wrong"
  );
}
